import React from "react";
import { shallow } from "zustand/shallow";
import { Switch } from "@mantine/core";

import useAppStore from "./effort-point-settings-store";

export default function WinnerRules({ canEditWinnerRules = true, onUpdate }) {
  const { settings } = useAppStore(
    (state) => ({
      settings: state.settings,
    }),
    shallow
  );
  return (
    <div>
      <Switch
        disabled={!canEditWinnerRules}
        mt="lg"
        label="Prevent prize winners and finalists from winning other prizes"
        checked={settings.winner_rules.one_prize_per_winner}
        onChange={() =>
          onUpdate({
            one_prize_per_winner: !settings.winner_rules.one_prize_per_winner,
          })
        }
      />
    </div>
  );
}
